export class EmailSetting {
  MailSender: string;
  MailUsername: string;
  MailPassword: string;
  MailHost: string;
  MailPort: number;
  MailEncryptionNumber: number;

  constructor() {
    this.MailSender = null;
    this.MailUsername = null;
    this.MailPassword = null;
    this.MailHost = null;
    this.MailPort = 0;
    this.MailEncryptionNumber = 0;
  }
}